<template>
  <!-- <div class="outer-ring center"></div>
    <div class="inner-ring center"></div> -->
  <a href="/" @click="handleLogoClick" class="logo" :class="getLogoClasses" :style="getCustomStyles">
    <!-- <IconBase
        icon-name="logo"
        iconColor="#444"
        viewBox="0 0 3167.5977653631285 988.826815642458"
        width="100%"
        height="100%"
        strokeWidth="0px"
        ><IconLogo
      /></IconBase> -->
    <div class="logoIcon" :class="isSessionLoader ? 'medium-logo-icon' : ''">
      <IconBase icon-name="logo-icon" iconColor="#444" viewBox="83.799 83.799 821.229 821.229" width="100%" height="100%" strokeWidth="0px"
        ><LogoIconBlack
      /></IconBase>
    </div>
    <div class="logoText" :class="isSessionLoader ? 'medium-logo-text' : ''">
      <IconBase icon-name="logo-text" iconColor="#444" viewBox="1072.626 310.056 2011.173 376.864" width="100%" height="100%" strokeWidth="0px"
        ><LogoTextBlack
      /></IconBase>
    </div>
  </a>
</template>

<script>
import IconBase from "@/components/IconBase";
// import IconLogo from "../../../components/SVG/IconLogo";
import LogoIconBlack from "@/components/SVG/LogoIconBlack";
import LogoTextBlack from "@/components/SVG/LogoTextBlack";

export default {
  name: "CalendarNav",
  props: {
    customStyle: {
      type: String,
      default: "",
    },
    isSessionLoader: Boolean,
    isSession: Boolean,
    isSubscription: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    IconBase,
    // IconLogo,
    LogoIconBlack,
    LogoTextBlack,
  },
  computed: {
    getCustomStyles() {
      let styles = "";
      if (this.customStyle) {
        styles += this.customStyle;
      }
      return styles;
    },
    getLogoClasses() {
      let classes = "";
      if (this.isSessionLoader) {
        classes = "medium-logo";
      } else if (this.isSession) {
        classes = "session-logo";
      } else if (this.isSubscription) {
        classes = "subscription-logo";
      }
      return classes;
    },
  },
  methods: {
    handleLogoClick() {
      if (this.isSessionLoader || this.isSession) {
        return;
      }
      /* UX makes sense that user clicking there might be trying to exit settings. */
      this.$store.commit("cofocusPreferences/SET_SETTINGS_OPEN", false);
      /* Router disabled for people with ads */
      // if (this.$route.path !== "/") {
      //   this.$router.push("/");
      // }
    },
  },
};
</script>

<style scoped>
.logo {
  /* height: 30px; */
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 12px;
  transform: scale(1.04);
}
.logoIcon {
  width: 25px;
  height: 25px;
}

.logoText {
  height: 13px;
  width: 84px;
}

.subscription-logo {
  transform: scale(1.1);
}

.session-logo {
  transform: scale(1.05);
  margin-right: 20px;
  margin-left: 2px;
  cursor: default;
}

.medium-logo {
  transform: scale(2.2);
  margin-bottom: 36px;
  margin-right: 4px;
  cursor: default;
}
.medium-logo-text {
  height: 14px;
  width: 85px;
}
.medium-logo-icon {
  width: 25px;
  height: 25px;
}

/* .outer-ring {
  position: absolute;
  left: 10px;
  height: 29px;
  top: 6px;
  width: 29px;
  background-image: linear-gradient(
135deg
, #FEED07 0%, #FE6A50 5%, #ED00AA 15%, #2FE3FE 50%, #8900FF 100%); 
  border-radius: 50%;
  animation-duration: 2s;
  animation-name: rotate;
  animation-iteration-count: infinite;
  background-color: #26006f;
}

.inner-ring {
  position: absolute;
  left: 12.5px;
  height: 23.5px;
  top: 8.5px;
  width: 23.5px;
  background-image: linear-gradient(
    135deg,
    #feed07 0%,
    #fe6a50 5%,
    #ed00aa 15%,
    #2fe3fe 50%,
    #8900ff 100%
  );
  border-radius: 50%;
  animation: gradient 15s ease infinite;
  background-size: 400% 400%;
  opacity: 98%;
} */
</style>
